module.exports = __webpack_public_path__ + "img/bj-golden-strawberry.c187dac8.gif";